class TabManager {
  constructor(
    wrapper,
    defaultTabText = "Tab",
    sectionClass = "wp-block-voyager-tab-wrapper__tab-block"
  ) {
    this.wrapper = wrapper;
    this.sections = this.findSections();
    this.defaultTabText = defaultTabText;
    this.sectionClass = sectionClass;
    this.init();
    // this.handleResize();
  }

  findSections() {
    const sections = [];
    const allSections = this.wrapper.querySelectorAll("section, .wp-block-voyager-block-wrapper");
  
    allSections.forEach((element) => {
      // Check if it's a div wrapper with nested sections
      if (element.classList.contains("wp-block-voyager-block-wrapper")) {
        // Remove IDs from all sections inside this div wrapper
        element.querySelectorAll("section").forEach((nestedSection) => {
          nestedSection.removeAttribute("id");
        });
      }
  
      // Add the element to sections if it's a direct section or a wrapper div
      if (element.tagName === "SECTION" || element.classList.contains("wp-block-voyager-block-wrapper")) {
        sections.push(element);
      }
    });
  
    return sections.filter(Boolean);
  }

  init() {
    if (this.sections.length === 0) {
      console.warn("No sections found.");
      return;
    }
    this.createTabList();
    this.createAccordionHeaders();
    this.hideAllSectionsExceptFirst();
    this.addTabClickHandlers();
    this.addAccordionClickHandlers();
    this.activateTab(0);
    // window.addEventListener("resize", this.handleResize.bind(this));
  }

  createTabList() {
    this.tabList = document.createElement("ul");
    this.tabList.className = "wp-block-voyager-tab-wrapper__tab-list";
    this.tabList.setAttribute("role", "tablist");
  
    const wrapperId = this.wrapper.id || `tab-wrapper-${Math.random().toString(36).substr(2, 9)}`;
    let tabIndex = 0;
    let panelIndex = 0;
  
    // First pass: Create all tabs
    this.sections.forEach((section) => {
      const isTabListItem = section.classList.contains('wp-block-voyager-tab-wrapper__tab-list-item');
      const isDivWrapper = section.classList.contains("wp-block-voyager-block-wrapper");
  
      const shouldCreateTab = isTabListItem || 
        (isDivWrapper ? section.querySelectorAll("section").length === 0 : true);
  
      if (shouldCreateTab) {
        let tabName;
        if (isTabListItem) {
          tabName = section.textContent || `${this.defaultTabText} ${tabIndex + 1}`;
        } else {
          tabName = this.getTabName(section) || `${this.defaultTabText} ${tabIndex + 1}`;
        }
  
        const tabId = `tab-${wrapperId}-${tabIndex}`;
        const panelId = `panel-${wrapperId}-${tabIndex}`;
  
        const tabListItem = document.createElement("li");
        tabListItem.textContent = tabName;
        tabListItem.dataset.index = tabIndex;
        tabListItem.className = "wp-block-voyager-tab-wrapper__tab-list-item";
        tabListItem.setAttribute("role", "tab");
        tabListItem.setAttribute("aria-controls", panelId);
        tabListItem.id = tabId;
        tabListItem.setAttribute("aria-selected", tabIndex === 0 ? "true" : "false");
        tabListItem.setAttribute("tabindex", tabIndex === 0 ? "0" : "-1");
  
        this.tabList.appendChild(tabListItem);
        tabIndex++;
      }
    });
  
    // Second pass: Set up panels
    this.sections.forEach((section) => {
      const isTabListItem = section.classList.contains('wp-block-voyager-tab-wrapper__tab-list-item');
      const isDivWrapper = section.classList.contains("wp-block-voyager-block-wrapper");
  
      if (!isTabListItem) {
        section.classList.add(this.sectionClass);
        
        if (isDivWrapper) {
          // For wrapper divs, remove ARIA attributes from inner sections
          section.querySelectorAll("section").forEach(innerSection => {
            innerSection.removeAttribute("id");
            innerSection.removeAttribute("aria-labelledby");
            innerSection.removeAttribute("role");
            innerSection.removeAttribute("hidden");
          });
          
          // Set attributes only on the wrapper div
          const currentTabId = `tab-${wrapperId}-${panelIndex}`;
          const currentPanelId = `panel-${wrapperId}-${panelIndex}`;
          
          section.setAttribute("role", "tabpanel");
          section.id = currentPanelId;
          section.setAttribute("aria-labelledby", currentTabId);
          section.setAttribute("tabindex", "0");
          
          if (panelIndex !== 0) {
            section.setAttribute("hidden", "");
          }
          
          panelIndex++;
        } else if (!section.closest('.wp-block-voyager-block-wrapper')) {
          // Only set attributes on sections that are not inside a wrapper div
          const currentTabId = `tab-${wrapperId}-${panelIndex}`;
          const currentPanelId = `panel-${wrapperId}-${panelIndex}`;
          
          section.setAttribute("role", "tabpanel");
          section.id = currentPanelId;
          section.setAttribute("aria-labelledby", currentTabId);
          section.setAttribute("tabindex", "0");
          
          if (panelIndex !== 0) {
            section.setAttribute("hidden", "");
          }
          
          panelIndex++;
        }
      }
    });
  
    const container = document.createElement("div");
    container.className = "voyager-container voyager-container__tab-container";
    container.appendChild(this.tabList);
  
    this.wrapper.insertBefore(container, this.wrapper.firstChild);
  }  

  createAccordionHeaders() {
    this.sections.forEach((section, index) => {
      let tabName = this.getTabName(section);
      if (!tabName) {
        tabName = `${this.defaultTabText} ${index + 1}`;
      }
      const header = document.createElement("div");
      header.textContent = tabName;
      header.className = "wp-block-voyager-tab-wrapper__accordion-header voyager-icon-chevron-pointing-down";
      header.dataset.index = index;

      section.insertBefore(header, section.firstChild);
    });
  }

  getTabName(section) {
    // const header = section.querySelector("header");
    const headingElement = section.querySelector(".voyager-intro-text__heading");
    if (headingElement) {
      const headerText = headingElement.textContent.trim();
      // console.log('headerText', headerText);
      
      if (headerText) {
        return headerText;
      }
    }
    return null;
  }

  hideAllSectionsExceptFirst() {
    this.sections.forEach((section, index) => {
      if (index !== 0) {
        section.style.display = "none";
      } else {
        section.style.display = "block";
      }
    });
  }

  addTabClickHandlers() {
    this.tabList.addEventListener("click", (event) => {
      if (event.target.tagName === "LI") {
        const index = event.target.dataset.index;
        this.activateTab(index);
      }
    });

    this.tabList.addEventListener("keydown", (event) => {
      const currentTab = event.target;
      if (
        currentTab.tagName === "LI" &&
        currentTab.getAttribute("role") === "tab"
      ) {
        let newIndex;
        switch (event.key) {
          case "ArrowRight":
          case "ArrowDown":
            newIndex =
              (parseInt(currentTab.dataset.index) + 1) % this.sections.length;
            break;
          case "ArrowLeft":
          case "ArrowUp":
            newIndex =
              (parseInt(currentTab.dataset.index) - 1 + this.sections.length) %
              this.sections.length;
            break;
          case "Home":
            newIndex = 0;
            break;
          case "End":
            newIndex = this.sections.length - 1;
            break;
          default:
            return;
        }
        this.activateTab(newIndex);
        this.tabList.children[newIndex].focus();
      }
    });
  }

  addAccordionClickHandlers() {
    this.wrapper.addEventListener("click", (event) => {
      if (event.target.classList.contains("wp-block-voyager-tab-wrapper__accordion-header")) {
        const index = event.target.dataset.index;
        this.toggleAccordion(index);
      }
    });
  }

  toggleAccordion(index) {
    const section = this.sections[index];
    const isActive = section.classList.contains("js-accordion-active");
    this.sections.forEach(sec => sec.classList.remove("js-accordion-active"));
    if (!isActive) {
      section.classList.add("js-accordion-active");
    }
  }

  activateTab(index) {
    const parsedIndex = parseInt(index);
  
    // Update tabs
    this.tabList.querySelectorAll("li").forEach((li, liIndex) => {
      const isActive = liIndex === parsedIndex;
      li.classList.toggle("js-active-tab", isActive);
      li.setAttribute("aria-selected", isActive.toString());
      li.setAttribute("tabindex", isActive ? "0" : "-1");
    });
  
    // Update panels
    let panelIndex = 0;
    this.sections.forEach((section) => {
      const isTabListItem = section.classList.contains('wp-block-voyager-tab-wrapper__tab-list-item');
      const isDivWrapper = section.classList.contains("wp-block-voyager-block-wrapper");
  
      if (!isTabListItem) {
        if (isDivWrapper || !section.closest('.wp-block-voyager-block-wrapper')) {
          const isActive = panelIndex === parsedIndex;
          
          if (window.innerWidth <= 992) {
            // Mobile accordion view
            section.style.display = "block";
            section.classList.toggle("js-accordion-active", isActive);
            section.removeAttribute("hidden");
          } else {
            // Desktop tab view
            if (isActive) {
              section.style.display = "block";
              section.removeAttribute("hidden");
            } else {
              section.style.display = "none";
              section.setAttribute("hidden", "");
            }
          }
          
          // If it's a wrapper div, ensure inner sections are always visible
          if (isDivWrapper) {
            section.querySelectorAll("section").forEach(innerSection => {
              if (innerSection.classList.contains('voyager-text-content')) {
                innerSection.style.display = "none";
              }
            });
          }
          
          panelIndex++;
        }
      }
    });
  }
  
  handleResize() {
    if (window.innerWidth <= 992) {
      // Convert to accordion
      this.tabList.style.display = "none";
      this.sections.forEach((section) => {
        const header = section.querySelector(".wp-block-voyager-tab-wrapper__accordion-header");
        if (!header) {
          this.createAccordionHeaders();
        }
        section.classList.remove("js-accordion-active"); // Ensure no accordion is active initially
        section.style.display = "block"; // Make all sections visible in accordion mode
        section.removeAttribute("hidden"); // Ensure accessibility in accordion mode
      });
    } else {
      // Convert to tabs
      this.tabList.style.display = "flex";
      this.sections.forEach((section, index) => {
        const header = section.querySelector(".wp-block-voyager-tab-wrapper__accordion-header");
        if (header) {
          header.remove();
        }
        section.style.display = index === 0 ? "block" : "none";
        section.toggleAttribute("hidden", index !== 0); // Hide non-active sections
      });
      this.activateTab(0); // Reset to the first tab
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const wrappers = document.querySelectorAll(".wp-block-voyager-tab-wrapper");
    wrappers.forEach(wrapper => {
      new TabManager(wrapper);
    });
  }, 200);
});
